'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsFromItem = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require('lodash');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropsFromItem = exports.getPropsFromItem = function getPropsFromItem(item, mapToProps, allowUndefined, state, sources) {
  var propsFromItem = {};

  (0, _keys2.default)(mapToProps).forEach(function (key) {
    if (state && (0, _typeof3.default)(mapToProps[key]) === 'object' && (0, _lodash.has)(mapToProps[key], 'path')) {
      var propVal = mapToProps[key].path === '$' ? item : (0, _lodash.get)(item, mapToProps[key].path);
      var resolve = function resolve(state, val) {
        return val;
      };

      if ((0, _lodash.has)(mapToProps[key], 'resolve')) {
        resolve = mapToProps[key].resolve;
      }

      var value = resolve(state, propVal) || 'undefined';
      propsFromItem[key] = (0, _bdcoreUtilities.Slugify)(value.toString());
      return;
    }

    var prop = (0, _lodash.get)(item, mapToProps[key], (0, _lodash.get)(sources, mapToProps[key]));

    if (typeof prop === 'string') {
      propsFromItem[key] = (0, _bdcoreUtilities.Slugify)(prop);
    }

    if (prop === undefined && allowUndefined) {
      propsFromItem[key] = undefined;
    }
  });

  return propsFromItem;
};

var paramsMatch = function paramsMatch(params, mapToProps, item) {
  var exact = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var state = arguments[4];

  var propsFromItem = getPropsFromItem(item, mapToProps, null, state);

  if (exact && (0, _keys2.default)(params).length === 0) {
    return false;
  }

  var response = (0, _keys2.default)(params).reduce(function (match, key) {
    if (exact && !propsFromItem[key] || propsFromItem[key] && propsFromItem[key] !== decodeURIComponent(params[key])) {
      return false;
    }

    return match;
  }, true);
  return response;
};

exports.default = paramsMatch;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-named-routes/build/paramsMatch.js
// module id = 989
// module chunks = 0